import {
  Component,
  OnInit,
  OnDestroy,
  ViewEncapsulation,
  AfterViewInit,
  Input,
  ElementRef,
  ViewChild,
  EventEmitter
} from '@angular/core';
import { Helpers } from '../../../helpers';
import { Router } from '@angular/router';
import { CustomerSearchService } from '../../../_services/main/customer-search.service';
import { PortalV2Service } from '../../../_services/main/portalv2.service';
import { DashboardService } from '../../../_services/main/dashboard.service';
import { AuthService } from '../../../_services/main/auth.service';
import { Subject } from 'rxjs/Subject';
import { ToastrService } from 'ngx-toastr';
import { environment } from '../../../../environments/environment';
import {
  EMPLOYEES,
  onboardingTypeToNameMap,
  employeeTypeToRoleNameMap
} from '../../../../../config/common-lists';

import Swal from 'sweetalert2';
import { PubNubService } from '../../../_services/main/pubnub.service';

declare let mLayout: any;
declare const Pusher: any;
declare const PubNub: any;

@Component({
  selector: 'app-header-portal',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
  providers: [CustomerSearchService],
  encapsulation: ViewEncapsulation.None
})
export class HeaderPortalComponent implements OnInit, AfterViewInit, OnDestroy {
  @Input()
  activeTab: any;
  customers: any;

  searchTerm$ = new Subject<string>();
  showCustomersList = false;
  @ViewChild('searchBox')
  searchBox: ElementRef;

  currentUser: any;
  pusher: any;
  pusherChannel: any;
  showAddCustomers = false;
  addNewCustomerMail: any;
  addNewCustomerPhone: any;
  addNewCustomerName: any;
  customerObj: any;
  showCustomerNavigation = false;
  customerRequests = [];

  employeeTypeToRoleNameMap = employeeTypeToRoleNameMap;
  onboardingTypeToNameMap = onboardingTypeToNameMap;
  assigneeMap = EMPLOYEES;

  constructor(
    private _router: Router,
    private searchService: CustomerSearchService,
    private toastr: ToastrService,
    private _portalService: PortalV2Service,
    private _authService: AuthService,
    private _dashboardService: DashboardService,
    private pubnubService: PubNubService
  ) {
    this.searchService.search(this.searchTerm$).subscribe(results => {
      if (results && results.data) {
        this.customers = results.data.customers;
        for (var i = 0; i < this.customers.length; i++) {
          this.customers[i].csrNameAbbr = this.getCSRName(this.customers[i]);
        }
        this.showCustomersList = true;
      }
    });
  }
  ngOnInit() {
    this.currentUser = JSON.parse(localStorage.getItem('CURRENT_USER'));
    this.pubnubService.subscribeTo();
    this.pubnubService.$pubnubEmitter.subscribe(msg => {
      this.handlePubnubMsgs(msg);
    });
    // this.initializePubNub();
  }

  handlePubnubMsgs(msg) {
    //conditions
    console.log('pubnub msg', msg);
    this.getLoggedInEmployee();
  }

  ngAfterViewInit() {
    this.getCustomerRequests();
    (<any>mLayout).initHeader();
    this._portalService.$pubnumEmitter.subscribe(data => {
      console.log(data, 'dataa');
      if (data.msg === 'updateCustomerRequests') {
        this.getCustomerRequests();
      }
      if (data.msg === 'updateCustomerChat') {
        this._portalService.$onTextMsgRecieve.emit(data.msg);
      }
    });
  }

  ngOnDestroy() {
    // this.pusherChannel.unbind();
  }
  logout(): void {
    // clear token remove user from local storage
    localStorage.removeItem('currentUser');
    localStorage.clear();
    this._router.navigate(['/login']);
  }

  getCustomerRequests() {
    const data = {
      resolved: false
    };
    this._dashboardService.getCustomerRequests(data).subscribe(
      resp => {
        console.log(resp, 'data');
        this.customerRequests = resp.data.result.customerRequests;
      },
      error => {
        console.log(error, 'error');
      }
    );
  }

  closeCustomersList() {
    this.showCustomersList = false;
    this.searchBox.nativeElement.value = '';
  }

  createCustomerFromPortal() {
    const customerEmail = this.addNewCustomerMail;
    let customerName = this.addNewCustomerName;
    const customerPhone = this.addNewCustomerPhone;
    if (customerName === '' || typeof customerName === undefined || customerName === null) {
      customerName = customerEmail;
    }
    if (
      customerEmail &&
      customerEmail.indexOf('@') > 0 &&
      customerName &&
      customerPhone.length === 10
    ) {
      this._authService.signup(customerEmail, customerPhone, customerName).subscribe(
        response => {
          if (response && response.data && response.data.status) {
            this.alert('success', 'Done!', 'Customer Created');
            if (response.data.result && response.data.result.customer) {
              const customerId = response.data.result.customer._id;
              this._dashboardService.fetchUserAccountDetails(customerId).subscribe((resp: any) => {
                if (resp.data && resp.data.customer) {
                  this.customerObj = resp.data.customer;
                  this.showCustomerNavigation = true;
                  this.addNewCustomerMail = '';
                  this.addNewCustomerName = '';
                  this.addNewCustomerPhone = '';
                }
              });
            }
          } else {
            this.alert(
              'error',
              'Failed!',
              'Please make sure that the created customer is unique and email/phone id is not mapped/linked with any other customer account',
              7000
            );
          }
        },
        error => {
          this.alert(
            'error',
            'Failed!',
            'Please make sure that the created customer is unique and email/phone id is not mapped/linked with any other customer account',
            7000
          );
          console.log('error', error);
        }
      );
    } else {
      // form contains invalid values
    }
  }

  navigateCustomerFromPortal() {
    if (this.customerObj) {
      this.openCustomerCard(this.customerObj);
    }
  }

  openCustomerCard(customer) {
    this.showCustomersList = false;
    let url = '';
    if (customer.customerCardId) {
      url = '/portal/customer/' + customer.customerCardId;
    } else {
      url = '/portal/customer/id-' + customer._id;
    }

    this._router.navigate([url]);
    this.customerObj = '';
    this.showCustomerNavigation = false;
  }

  showSuccess() {
    this.toastr.success('Hello world!', 'Toastr fun!');
  }

  alert(type, title, text, time?) {
    Swal({
      type: type,
      title: title,
      text: text,
      allowOutsideClick: false,
      showConfirmButton: false,
      timer: time || 2000
    }).then(() => {});
  }

  pushCard() {
    const card = {
      _id: '5bd6d19e8a3ae434129b2976',
      updatedAt: '2018-10-29T09:23:42.620Z',
      createdAt: '2018-10-29T09:23:42.620Z',
      cardId: 'o5viq6',
      cardType: 'customer',
      stageId: 'missingAccountCreds',
      previousStageId: 'missingCC',
      boardId: 'chaser',
      customer: {
        customerId: '5bd6d19e8a3ae434129b2971',
        name: 'deepaktest4@billtrim.com',
        email: 'deepaktest4@billtrim.com',
        cardVerified: 'false',
        _id: '5bd6d19e8a3ae434129b2977'
      },
      tags: [],
      __v: 0,
      employee: {
        employeeId: '5af9a9b7a0ae5835a4f14afa'
      },
      hideUntil: '2018-10-29T19:01:42.620Z'
    };
    this._portalService.$onNotificationsPush.emit(card);
  }

  resolveStickyItems(item) {
    const data = {
      _id: item._id,
      resolved: true
    };
    this._dashboardService.updateCustomerRequests(data).subscribe(
      resp => {
        console.log(resp, 'data');
        this.getCustomerRequests();
      },
      error => {
        console.log(error, 'error');
      }
    );
  }

  getCSRName(customer) {
    var csrNameAbbr = '';
    if (customer.csrId) {
      const emp = this.assigneeMap.filter(emp => emp.id == customer.csrId);
      if (emp.length > 0) {
        var a = emp[0].fullname.split(' ');
        csrNameAbbr = a[0][0] + a[1][0];
      } else {
        csrNameAbbr = '--';
      }
    } else {
      csrNameAbbr = '--';
    }
    return csrNameAbbr;
  }

  getLoggedInEmployee() {
    this._authService.getLoggedInUser({ _id: this.currentUser._id }).subscribe(
      data => {
        console.log(data);
        this.currentUser = { ...this.currentUser, ...data };
        localStorage.setItem('CURRENT_USER', JSON.stringify(this.currentUser));
        this._portalService.getCurrentUser();
      },
      error => {
        console.log(error);
      }
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/portalV2/common/header/header.component.ts